import { render, staticRenderFns } from "./DueDate.vue?vue&type=template&id=ff568d30&"
import script from "./DueDate.vue?vue&type=script&lang=js&"
export * from "./DueDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports